import React from "react"
import { ListGroup, Spinner } from "react-bootstrap"
import { Dash, Plus } from "react-bootstrap-icons"
import { FleetBadge } from "@src/components/FleetBadge/FleetBadge"
import { colors } from "../../../../constants"

const CIconSize = 24

type Props = {
  itemId: number
  text: string
  badgeText?: string
  onPress: (itemId: number) => void
  iconType: "add" | "remove"
  loading: boolean
}

export const ListGroupItem: React.FC<Props> = ({
  itemId,
  text,
  badgeText,
  onPress,
  iconType,
  loading,
}) => {
  return (
    <ListGroup.Item
      onClick={() => onPress(itemId)}
      disabled={loading}
      style={{ cursor: "pointer" }}
      className="d-flex align-items-center justify-content-between"
    >
      <div>
        {text}
        {badgeText && <FleetBadge fleetName={badgeText} className="ms-2" />}
      </div>
      {loading ? (
        <Spinner animation="border" size="sm" />
      ) : iconType === "add" ? (
        <Plus color={colors.green} size={CIconSize} />
      ) : (
        <Dash color={colors.red} size={CIconSize} />
      )}
    </ListGroup.Item>
  )
}
